import { useApiClient } from "@/hooks/useApiClient";
import useSWR from "swr";
import {
  type PublicLandPriceRequest,
  type PublicLandPriceResponse,
} from "@/features/publicLandPrice/types";
import { HttpStatusCode, isAxiosError } from "axios";
import { toast } from "react-toastify";

const url = "/public-land-price";

/**
 * 公示価格 詳細単一取得API
 * - 失敗の場合はリトライしない
 * @param request リクエスト情報
 * @returns 成功ならPublicLandPriceResponse、失敗ならundefined
 */
export const PublicLandPriceGetAPI = (
  request: PublicLandPriceRequest
): PublicLandPriceResponse | undefined => {
  const { apiClient } = useApiClient();

  const fetcher = async (
    id: number
  ): Promise<PublicLandPriceResponse | undefined> => {
    const { data } = await apiClient
      .get<PublicLandPriceResponse>(`${url}/${id}`)
      .catch((reason) => {
        throw reason;
      });
    return data;
  };

  const { data } = useSWR<PublicLandPriceResponse | undefined>(
    [request.id],
    fetcher,
    {
      revalidateOnFocus: true,
      onError: (err) => {
        if (isAxiosError(err)) {
          if (err.status === HttpStatusCode.NotFound) {
            toast.error("指定のデータが存在しません");
          } else if (err.status === HttpStatusCode.InternalServerError) {
            toast.error(
              "データの取得に失敗しました。しばらく経ってから再度お試しください"
            );
          }
        }
      },
      shouldRetryOnError: false, // エラー時にリトライしない
    }
  );
  return data;
};
